export const URL_PARAMS = new URLSearchParams(window.location.search);
export const ENV = window.projectGlobals.env;
export const LOCATION_HASH = window.location.hash;


// WEBPACK FOOTER //
// ./src/assets/js/utils/constants.js